import React from 'react';
import PropTypes from 'prop-types';
import Countdown from 'react-countdown-now';
import { formatNumber, padNumber } from 'utils/formatting';
import shouldUpdate from 'utils/shouldUpdate';
import { TOURNAMENT_STATUS_UPCOMING } from 'utils/tournaments';
import './MiniLeaderboard.css';

const DEFAULT_WINNING_PLACES = [1];

const timeRenderer = ({ days, hours, minutes, seconds }) => {
  let output = '';
  if (days) {
    output += padNumber(days) + ':';
  }
  if (days || hours) {
    output += padNumber(hours) + ':';
  }
  output += padNumber(minutes) + ':' + padNumber(seconds);
  return <span className="notranslate">{output}</span>;
};

function MiniLeaderboard({ userScore, countdownTo, tournament }) {
  const places =
    tournament &&
    tournament.winningPlaces &&
    tournament.winningPlaces.winningPlaces &&
    tournament.winningPlaces.winningPlaces.map(p => p.place);
  const rank = userScore.rank !== undefined ? userScore.rank : '-';
  const score =
    userScore.score !== undefined
      ? `${formatNumber(userScore.score)} points`
      : 'N/A';
  const winning =
    score > 0 && (places || DEFAULT_WINNING_PLACES).indexOf(rank) !== -1;
  const upcoming =
    tournament && tournament.status === TOURNAMENT_STATUS_UPCOMING;
  const countdownLabel = upcoming ? 'STARTING IN' : 'TIME REMAINING';
  return (
    <div className={`mini-leaderboard${winning ? ' winning-place' : ''}`}>
      <div className="info">
        <div className="score">
          <div className="info-label">YOUR SCORE</div>
          <div className="info-value notranslate">{score}</div>
        </div>
        <div className="timer">
          <div className="info-label">{countdownLabel}</div>
          <div className="info-value">
            <Countdown
              key={countdownLabel}
              date={countdownTo}
              renderer={timeRenderer}
            />
          </div>
        </div>
      </div>
      <div className={`position${winning ? ' filled' : ''}`}>{rank}</div>
    </div>
  );
}

MiniLeaderboard.propTypes = {
  tournament: PropTypes.object,
  userScore: PropTypes.shape({
    score: PropTypes.number,
    rank: PropTypes.number
  }),
  countdownTo: PropTypes.number
};

function shouldComponentUpdate(props, nextProps) {
  return (
    props.userScore.score !== nextProps.userScore.score ||
    props.userScore.rank !== nextProps.userScore.rank ||
    props.countdownTo !== nextProps.countdownTo
  );
}

export default shouldUpdate(shouldComponentUpdate)(MiniLeaderboard);
